// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.101.3/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._eC11 {
  padding: 32px;
  border: 1px solid #ff4d4f;
  border-radius: 12px;
  background-color: #fff2f0;
  text-align: center;
}
._eC11 .M9p4H {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #ff4d4f;
  font-size: 16px;
}
._eC11 .M9p4H .tO50C {
  padding: 8px 16px;
  background-color: #ff4d4f;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.3s;
}
._eC11 .M9p4H .tO50C:hover {
  background-color: #ff7875;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorFallback": `_eC11`,
	"errorMessage": `M9p4H`,
	"retryBtn": `tO50C`
};
export default ___CSS_LOADER_EXPORT___;
